// hooks/useUnmount.ts
import { useEffect, useRef } from "react";

/** Runs `fn` on real unmount; ignores React 18 StrictMode's dev-only unmount. */
export function useUnmount(fn: () => void) {
  const fnRef = useRef(fn);
  // always keep the latest function without changing the effect
  fnRef.current = fn;

  useEffect(() => {
    let armed = false;
    const id = setTimeout(() => { armed = true; }, 0); // arm after first tick

    return () => {
      clearTimeout(id);
      if (armed) fnRef.current();
    };
    // empty deps: run once per mount
  }, []);
}
